export default __webpack_public_path__ + "static/media/alto-maxx-logo.018efe03.webp";